<h2>CIAM login</h2>

<loading-bar [label]="'Authenticating'" *ngIf="loading"/>

<div *ngIf="!loading">
  <button *ngIf="!isAuthenticated" class="login-button" mat-raised-button color="primary" type="submit"
    (click)="login()">Login using CIAM</button>
  <div *ngIf="isAuthenticated">
    User logged in - <a routerLink="/search">go to main page</a>
  </div>

  <div class="debug-info" *ngIf="debug">
    <h3>Debug information</h3>
    <div *ngIf="isAuthenticated">
      <button (click)="logout()">Logout</button>
      <button (click)="logoffAndRevokeTokens()">Logout and revoke tokens</button>
      <button (click)="revokeAccessToken()">Revoke access token</button>
      <button (click)="revokeRefreshToken()">Revoke refresh token</button>
      <button (click)="refreshSession()">Refresh session</button>
      <hr />

      <br />

      Is Authenticated: {{ isAuthenticated }}

      <br />
      userData
      <pre>{{ userData$ | async | json }}</pre>

      <br />
    </div>

    Configuration loaded:
    <pre>{{ configuration$ | async | json }}</pre>
  </div>
</div>